import axios from "axios";
import {
  getDashboardDataStart,
  getDashboardDataSuccess,
  getDashboardDataFailure,
} from "./DashboardActions";
import { apiUrl } from "../../config";

export const getDashboardData = async (dispatch) => {
  dispatch(getDashboardDataStart());

  try {
    const response = await axios.get(
      apiUrl +
        "/salesforce/" +
        JSON.parse(sessionStorage.getItem("user")).salesforceAccountId +
        "/dashboard",
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user")).accessToken,
        },
      }
    );

    dispatch(getDashboardDataSuccess(response.data));
  } catch (error) {
    dispatch(getDashboardDataFailure());
  }
};
